import { apiGet, apiPost, setCsrfToken } from './api.js';
import { emit } from './dom.js';

const state = { user: null, loaded: false };

export function currentUser() { return state.user; }
export function isCoach()   { return state.user?.role === 'coach'; }
export function isStudent() { return state.user?.role === 'student'; }

export async function ensureSession() {
  if (state.loaded) return state.user;
  try {
    const data = await apiGet('/auth/me');
    state.user = data.user || null;
    setCsrfToken(data.csrf_token || null);
  } catch (err) {
    if (err.status === 401) {
      state.user = null;
      try {
        const c = await apiGet('/csrf');
        setCsrfToken(c.csrf_token || null);
      } catch (_) { /* no-op */ }
    } else {
      throw err;
    }
  }
  state.loaded = true;
  emit('auth:changed', state.user);
  return state.user;
}

export async function login(email, password) {
  const data = await apiPost('/auth/login', { email, password });
  state.user = data.user;
  state.loaded = true;
  setCsrfToken(data.csrf_token);
  emit('auth:changed', state.user);
  return state.user;
}

export async function logout() {
  try { await apiPost('/auth/logout', {}); } catch (_) {}
  state.user = null;
  state.loaded = true;
  try {
    const c = await apiGet('/csrf');
    setCsrfToken(c.csrf_token || null);
  } catch (_) {}
  emit('auth:changed', null);
}
